import {
  Channel,
  type Options,
  PresenceChannel,
  default as Pusher,
} from 'pusher-js';

export enum ConnectionState {
  ONLINE,
  OFFLINE,
  INIT,
}
export interface PusherContextValues {
  client?: Pusher;
  triggerEndpoint?: string;
  state: ConnectionState;
}

export interface ChannelsContextValues {
  subscribe?: <T extends Channel & PresenceChannel>(
    channelName: string
  ) => T | undefined;
  unsubscribe?: (channelName: string) => void;
  getChannel?: <T extends Channel & PresenceChannel>(
    channelName: string
  ) => T | undefined;
}
export interface PusherProviderProps extends Options {
  clientKey: string | undefined;
  triggerEndpoint?: string;
  value?: PusherContextValues;
}
